import { initTranslatedItems, parseComplexObject } from '../utils/translationProcessor';

export const CONS = {
  TITLE: 'We found a match',
  PAGE_TYPE: 'confirmation',
  TITLE_EMAIL: 'What\'s their email?',
  TEXT: 'To let you view and manage their prescriptions, we need their approval.',
  TEXT2: 'we need to email them to get their approval.',
  TEXT3: 'To let you view and manage this person\'s pharmacy records, we need their approval.',
  TEXT_EMAIL: 'We\'ll email or text them.',
  ADD_EMAIL: 'Add their email address so we can contact them.',
  TEXT_MINOR: 'To view and manage this person\'s pharmacy records, confirm that you\'re their legal guardian.',
  SEND_BUTTON: 'Send approval request',
  SUBMIT: 'Submit',
  CANCEL: 'Cancel',
  TAG: 'send_approval_request',
  LEGAL_GUARD: 'I am the legal guardian/parent',
  ADD: 'Their email address',
  EMAIL_PLACEHOLDER: 'Not your email address',
  FORM: 'confirmation-form',
  ERRORS: {
    EMPTY: 'Enter an email address',
    VALID: 'Enter a valid email address',
    MINOR: 'Select the checkbox to confirm you\'re their legal guardian'
  },
  ALERT: 'Please correct the following errors',
  ALERT_MINOR: 'Confirm adding a minor',
  MODAL: {
    LEAVE_NO_SAVE: 'Leave without saving?',
    WORK_LOST: 'Your work will be lost, and you\'ll need to start over again next time.',
    KEEP_WORKING: 'Keep working',
    LEAVE: 'Leave',
    SURE: 'Are you sure you want to quit'
  },
  LEGAL_GUARD_SUB:
    'By adding a minor to your account, you are confirming that you are the legal guardian/parent of the child and have authority to view and access their records.'
};

// Translation configuration for confirmation page
export const CONFIRMATION_TRANSLATION_CONFIG = [{ key: 'CONS', value: CONS, message: JSON.stringify(CONS) }];

// Helper function to process translated items
export const processConfirmationTranslations = (translatedItems: any) => {
  translatedItems = initTranslatedItems(translatedItems);

  return {
    CONS: parseComplexObject(translatedItems, CONS)
  };
};
